import { render, staticRenderFns } from "./DeliveryTerms.vue?vue&type=template&id=5100468e&scoped=true&"
import script from "./DeliveryTerms.vue?vue&type=script&lang=js&"
export * from "./DeliveryTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5100468e",
  null
  
)

export default component.exports